import { render, staticRenderFns } from "./DocTypeEdit.vue?vue&type=template&id=0088acdc&"
import script from "./DocTypeEdit.vue?vue&type=script&lang=js&"
export * from "./DocTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocTypeEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports